<template>
  <div>

     <v-card color="grey">
          <v-toolbar color="grey" dark>
            <v-btn outlined small fab color="white" @click="goback()">
              <v-icon>mdi-arrow-left-bold</v-icon>
            </v-btn>

            <v-toolbar-title class="ml-2">Login Detail1</v-toolbar-title>

            <v-spacer></v-spacer>

            <!-- <v-btn icon>
        <v-icon>mdi-magnify</v-icon>
      </v-btn> -->
            <v-btn medium color="primary" @click="New()">
              <v-icon>mdi-plus</v-icon>
              NEW
            </v-btn>

            <!-- <v-btn medium color="error" class="ml-2" @click="Reload(this.$store.state.eventInfo.EventId)">VIEW</v-btn> -->
          </v-toolbar>
        </v-card>

 <v-card class="mt-4 pt-2 pb-2" flat>
      <v-card-actions>
<v-row>
    <v-col cols="12" md="4" sm="12">
 <v-select
          outlined
          v-model="SelEvent"
          :items="EventName"
          item-text="event_name"
          item-value="event_id"
          label="Select Event"
          dense
          :rules="[(v) => !!v || 'Event is required']"
          required
        
          hide-details
          full-width
        ></v-select>
    </v-col>
    <v-col cols="12" md="4" sm="12">
         <v-select
          outlined
          v-model="SelVenue"
          :items="VenueName"
          item-text="venue_name"
          item-value="venue_id"
          label="Select Venue"
          dense
          :rules="[(v) => !!v || 'Venue is required']"
          required
        
          hide-details
          full-width
        ></v-select>
    </v-col>

<v-col cols="12" md="2" sm="12">
       
          <v-btn
              outlined
              medium
              color="primary"
              v-bind="attrs"
              class="pl-2 ma-1"
              @click="searchdata()"
            >
              <v-icon>mdi-magnify</v-icon>
              SEARCH
            </v-btn>
  </v-col>
  <v-col cols="12" md="2" sm="12">
      <v-btn
              outlined
              medium
              color="primary"
              v-bind="attrs"
              class="pl-2 ma-1"
              @click="New()"
            >
              <v-icon>mdi-plus</v-icon>
              NEW
            </v-btn>
            </v-col>

</v-row>

  
       
      </v-card-actions>
    </v-card>

    <div class="text-right">
      <template>
       
         

        <v-data-table
          :headers="headers"
          :items="desserts"
          sort-by="calories"
          class="elevation-1"
          :search="search"
          :loading="loadingstatus"
          loading-text="Loading... Please wait"
        >
          <template v-slot:top>
          
                        <v-text-field
              v-model="search"
              label="Search"
              single-line
              hide-details
              class="ml-4 mr-4 mb-5"
            ></v-text-field>
                  
          </template>

          <template v-slot:item.actions="{ item }">
            <v-icon small class="mr-2" @click="editItem(item)"
              >mdi-pencil</v-icon
            >
            <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
          </template>
          <template v-slot:no-data>
            <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
            No Record(s)
          </template>
        </v-data-table>
      </template>

      <v-navigation-drawer v-model="sheet" right persistent temporary  fixed style="width: 100%; max-width:800px; margin: auto">
        <v-sheet class="text-center" min-height="200px" color="#cccccc">
          <div class="text-left">
            <v-card
              flat
              max-width="800px"
              style="width: 100%; margin: auto"
              class="pa-3"
            >
              <v-toolbar color="transparent" flat>
                {{ EntryMode }} {{ VenueID }}
                <v-spacer></v-spacer>

                <v-btn icon light>
                  <v-icon color="grey darken-2" @click="sheet = !sheet"
                    >mdi-close</v-icon
                  >
                </v-btn>
              </v-toolbar>
              <v-divider></v-divider>
              <v-form ref="form" v-model="valid">
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6" md="12">
                      <v-text-field
                        v-model="postBody.name"
                        label="Name*"
                        outlined
                        required
                        dense
                        hide-details
                      ></v-text-field>
                    </v-col>

                     <v-col cols="12" sm="6" md="12">
                      <v-text-field
                        v-model="postBody.email"
                        label="Email*"
                        outlined
                        required
                        dense
                        hide-details
                      ></v-text-field>
                    </v-col>

                     <v-col cols="12" sm="6" md="12">
                      <v-text-field
                        v-model="postBody.pass"
                        label="Password*"
                        outlined
                        required
                        dense
                        hide-details
                      ></v-text-field>
                    </v-col>

                   

 <v-col cols="12" sm="6" md="6">
                      <v-select
          :items="userType"
          v-model="SeluserType"
          label="User Type"
          dense
          outlined
           hide-details
        ></v-select>
                    </v-col>

                    
 <v-col cols="12" sm="6" md="6">
                      <v-select
          :items="EditDeadline"
          v-model="SelEditDeadline"
          label="Edit Deadline"
          dense
          outlined
           hide-details
        ></v-select>
                    </v-col>

                  </v-row>
              
                <v-card-actions class="justify-center">
                  <v-btn
                    color="success"
                    :disabled="!valid"
                    raised
                    dark
                    large
                    @click="Save()"
                  >
                    SAVE
                  </v-btn>
                </v-card-actions>
  </v-container>

                <!-- <v-footer class="mt-6 justify-center">
          
        </v-footer> -->
              </v-form>
            </v-card>
          </div>
        </v-sheet>
      </v-navigation-drawer>
    </div>

    <v-snackbar v-model="snackbar" shaped top :color="snackbarcolor">
      {{ snackbartext }}
      <v-btn color="indigo" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
//import { mapMutations } from 'vuex'
import axios from "axios";
export default {
  data() {
    return {
      modal2: false,
      valid: false,
      snackbar: false,
      snackbartext: "",
      snackbarcolor: "primary",
      mode: "NEW",
      newmode: true,
      sheet: false,
      EntryMode: "",
      search: "",
      loadingstatus: false,
      isUploading: false,
      getcity_id: "",
      VenueID: "",
      SelVenue: "",
      VenueName: [],
      SelEvent: "",
      EventName: [],

      postBody: {
        name: "",
        email: "",
        pass: "",
        event_id: 0,
        venue_id:0,
        u_type:"",
        edit_deadline:"",
        created_by:1
      },

SeluserType:"",
       userType:[
        {text:"Admin", value:"Admin"},
        {text:"SubAdmin", value:"SubAdmin"},
        {text:"DnaAdmin", value:"DnaAdmin"},
        {text:"PrintAdmin", value:"PrintAdmin"},
        {text:"MediaAdmin", value:"MediaAdmin"},
        {text:"Scanner", value:"Scanner"},
      ],
SelEditDeadline:"",
       EditDeadline:[
        {text:"Yes", value:'Y'},
        {text:"No", value:'N'},
      ],

      headers: [
       
        { text: "Eid", value: "eaid" },
        { text: "Name", value: "name" },
        { text: "Email", value: "email" },
        { text: "User Type", value: "u_type" },
        { text: "Edit Deadline Access", value: "edit_deadline" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      desserts: [],
    };
  },
  mounted() {
    this.$store.commit("setPageTitle", "User Master");
   // this.Reload(2);
   this.bindEvent();
    this.bindVenue();
  },
  methods: {
    showSnackbar: function (scolor, stext) {
      this.snackbar = true;
      this.snackbartext = stext;
      this.snackbarcolor = scolor;
    },

    Reload: function (eid,vid) {
      this.loadingstatus = true;
      axios
        .get(this.$apiPath + "EventAdmin/GetByEIdVID/" + eid + "/" + vid, {
          headers: { Appkey: this.$aKey },
        })
        .then((res) => {
          this.desserts = res.data.result;
          console.log(res.data.result);
          this.loadingstatus = false;
        })
        .catch()
        .finally();
    },

     goback(){
this.$router.push("/admin/Events");
    },

    New() {
      this.EntryMode = "New User";
      this.ClearItem();
      this.bindVenue();
      this.sheet = true;
    },
    searchdata(){
      this.Reload(this.SelEvent,this.SelVenue);
    },

    Save() {
      this.$refs.form.validate();
this.postBody.venue_id = parseInt(this.SelVenue);
this.postBody.event_id = parseInt(this.SelEvent);
this.postBody.u_type=this.SeluserType;
this.postBody.edit_deadline=this.SelEditDeadline;
console.log(this.postBody);
      if (this.editedIndex > -1) {
        Object.assign(this.desserts[this.editedIndex], this.editedItem);
      } else {
        this.desserts.push(this.editedItem);
        if (this.EntryMode == "New User") {
          
          axios
            .post(this.$apiPath + "EventAdmin", this.postBody, {
              headers: { Appkey: this.$aKey },
            })
            .then((res) => {
              if (res.data.status == "Success") {
                this.showSnackbar("Success", "User Created!");
                // this.ClearItem();
                this.Reload(this.SelEvent,this.SelVenue);
                this.sheet = false;
              }
            })
            .catch()
            .finally();
        } else {
         
         console.log("edit");
         console.log(this.VenueID);
         console.log(this.postBody);
          axios
            .put(this.$apiPath + "EventAdmin/" + this.VenueID, this.postBody, {
              headers: { Appkey: this.$aKey },
            })
            .then((res) => {
              if (res.data.status == "Success") {
                // console.log(this.postBodyUpdate);
                this.showSnackbar("Success", "User Updated!");
                //  this.ClearItem();
                this.sheet = false;
                 this.Reload(this.SelEvent,this.SelVenue);
              }
            })
            .catch()
            .finally();
        }
      }
      //  this.close();
    },

    editItem(item) {
      this.EntryMode = "Edit User";

      this.VenueID = item.eaid;
      this.postBody.name = item.name;
      this.postBody.email = item.email;
      this.postBody.pass = item.pass;
      this.SeluserType=item.u_type;
      this.SelEditDeadline=item.edit_deadline;

    
      this.sheet = true;
      //  this.postBody.city_id = parseInt(this.SelCity.city_id);
      //  console.log(this.postBody);
    },

    ClearItem() {
      this.EntryMode = "New User";
      this.VenueID = "";
      this.postBody.name = "";
      this.postBody.email = "";
      this.postBody.pass = "";
      this.bindVenue();
      // this.SelCity = item.city_id;
      // this.sheet = true;
    },

    deleteItem(item) {
      //alert(item.Vendor_Id);
      const index = this.desserts.indexOf(item);
      if (confirm("Are you sure you want to delete this Venue?")) {
        axios
          .delete(this.$apiPath + "venue/" + item.venue_id, {
            headers: { Appkey: this.$aKey },
          })
          .then(() => {
            // this.desserts = res.data.result;
            this.showSnackbar("Success", "Venue Deleted !");
            this.Reload(this.SelVenue);
          })
          .catch()
          .finally();
      }
      this.desserts.splice(index, 1);
      this.Reload(this.SelVenue);
    },

    bindVenue: function () {
     
      axios
        .get(this.$apiPath + "Venue/GetVenueStadium", {
          headers: { Appkey: this.$aKey },
        })
        .then((res) => {
          this.VenueName = res.data.result;
          console.log("hi");
          console.log( res.data.result);
          
        })
        .catch()
        .finally();
    },

 bindEvent: function () {
     
      axios
        .get(this.$apiPath + "event", {
          headers: { Appkey: this.$aKey },
        })
        .then((res) => {
          this.EventName = res.data.result;
          
        })
        .catch()
        .finally();
    },

  },
};
</script>

<style>
</style>